import { render } from "./HeaderComponent.vue?vue&type=template&id=192963a8"
import script from "./HeaderComponent.vue?vue&type=script&lang=js"
export * from "./HeaderComponent.vue?vue&type=script&lang=js"

import exportComponent from "/builds/ASIP-Sante/g1/shared/santefr/web/modules/custom/sante_vuejs/vue-core/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/sharedComponents/HeaderComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "192963a8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('192963a8', __exports__)) {
    console.log('reload')
    api.reload('192963a8', __exports__)
  }
  
  module.hot.accept("./HeaderComponent.vue?vue&type=template&id=192963a8", () => {
    console.log('re-render')
    api.rerender('192963a8', render)
  })

}


export default __exports__